// extracted by mini-css-extract-plugin
export default {"form":"login_form__OBGEf","data":"login_data__MfwIC","input":"login_input__h7cJc","label":"login_label__nnceW","link":"login_link__j6O3h","main":"login_main__69AND"};